import React from 'react';

const UserPaymentMethodDetails = ({ paymentDetails = {} }) => {
  const {
    card_last_four,
    expiration_month,
    expiration_year,
    is_default,
    first_name,
    last_name,
    address,
    city,
    state,
    zip_code,
  } = paymentDetails;
  return (
    <table className="table table-striped">
      <tbody>
        <tr>
          <th>Card Number</th>
          <td>{card_last_four}</td>
        </tr>
        <tr>
          <th>Expiry Month</th>
          <td>{expiration_month}</td>
        </tr>
        <tr>
          <th>Expiry Year</th>
          <td>{expiration_year}</td>
        </tr>
        <tr>
          <th>First Name</th>
          <td>{first_name}</td>
        </tr>
        <tr>
          <th>Last Name</th>
          <td>{last_name}</td>
        </tr>
        <tr>
          <th>Address</th>
          <td>{address}</td>
        </tr>
        <tr>
          <th>City</th>
          <td>{city}</td>
        </tr>
        <tr>
          <th>State</th>
          <td>{state}</td>
        </tr>
        <tr>
          <th>Zip Code</th>
          <td>{zip_code}</td>
        </tr>
        <tr>
          <th>Is Default</th>
          <td>{is_default ? 'Yes' : 'No'}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default UserPaymentMethodDetails;
